export const REFRESH_SERVICE_WORKER = 'REFRESH_SERVICE_WORKER';

export const refreshServiceWorker = () => {
  return { type: REFRESH_SERVICE_WORKER };
};
